import { IRootStore } from '../store/rootStore';
import { Bucket } from '../bucket';
import { normalizeBlock } from '../block/normalizers';

import { PlannedEventServer } from './server';
import { IPlannedEvent } from './client';

export const normalizePlannedEvent = (
  raw: PlannedEventServer,
  stores: { rootStore: IRootStore }
): IPlannedEvent => {
  return {
    id: raw._id,
    date: new Date(raw.date),
    block: normalizeBlock(raw.block, stores),
    bucket: raw.bucket || Bucket.dev
  };
};
